import { Component, Input, OnChanges, OnInit, Optional, Self } from '@angular/core';

import { ControlValueAccessor, NgControl } from '@angular/forms';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { LexInputComponent } from '../lex-input/lex-input.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-select',
  templateUrl: './lex-select.component.html',
  styleUrls: ['./lex-select.component.scss'],
  standalone: false,
})
export class LexSelectComponent
  extends LexInputComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() options: any[];
  @Input() labelFormatter: (item) => string = (item) => item.label;
  @Input() valueAccessor: (item) => any = (item) => item;
  @Input() itemDisabled: (item) => boolean = () => false;

  constructor(@Self() @Optional() public ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes) {
    super.ngOnChanges(changes);
  }
}
